/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="95.51"
        height="95.59"
        viewBox="0 0 95.51 95.59"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#ffb81c"
          d="m59.38 33.56-2.5 2.51-.46-.32-.47-.31a8.53 8.53 0 0 0-8.19-.86 10.53 10.53 0 0 0-3.94 2.92 8.27 8.27 0 0 0-1.85 8.14 31.64 31.64 0 0 0 1.45 3.8c.63 1.57 1.33 3.11 2 4.67a2.84 2.84 0 0 1-1 3.39 3.09 3.09 0 0 1-3.94.43 8 8 0 0 1-1.54-1.24 4.85 4.85 0 0 1-1-6.1c.2-.41.44-.8.69-1.23l-5.28-3.12a12.44 12.44 0 0 0-2.07 6.26 10 10 0 0 0 2.48 6.72l-3.27 3.19 2.71 2.71 3.29-3.21c.65.44 1.27.88 1.92 1.27a8.8 8.8 0 0 0 8 .83 10.22 10.22 0 0 0 4.88-3.87 8.14 8.14 0 0 0 1.2-7.09 46 46 0 0 0-2.26-5.77c-.49-1.15-.92-2.33-1.32-3.51a2.5 2.5 0 0 1 .19-2 3.46 3.46 0 0 1 4.68-1.42l.12.06a4 4 0 0 1 2.07 3.53 7.82 7.82 0 0 1-.58 2.87l-.37.9 5.31 2.21a10.67 10.67 0 0 0 1.45-4.21 9.39 9.39 0 0 0-2.19-6.93l2.51-2.51Z"
          className="icon-fill icon-accent"
          fillRule="evenodd"/>
        <path
          fill="#fff"
          d="m74.84 0-24.7 1.05a1.24 1.24 0 0 0-.83.36L1.2 49.49a2.39 2.39 0 0 0-.23.22 4 4 0 0 0 .23 5.47l39.19 39.21a4 4 0 0 0 5.66 0l48.11-48.11a1.19 1.19 0 0 0 .32-.79l1-24.7a1.26 1.26 0 0 0-.36-.93L75.75.37a1.27 1.27 0 0 0-.91-.37Zm-.44 2.5 18.68 18.7-1 23.67-47.77 47.77a1.53 1.53 0 0 1-2.15 0L2.96 53.49a1.54 1.54 0 0 1-.1-2.06l.07-.06L50.75 3.49Z"
          className="icon-fill icon-base"/>
        <path
          fill="#fff"
          d="M68.12 16.63a7.81 7.81 0 1 0 11 .05v-.05a7.83 7.83 0 0 0-11 0Zm9.29 1.76a5.32 5.32 0 1 1-7.52 0 5.33 5.33 0 0 1 7.52 0Z"
          className="icon-fill icon-base"/>
        <path
          fill="#fff"
          d="M90.75 3.33a1.25 1.25 0 0 1 1.77 0 1.24 1.24 0 0 1 .09 1.66l-.09.11-18 17.93a1.25 1.25 0 0 1-1.86-1.66l.09-.1Z"
          className="icon-fill icon-base"/>
      </svg>

    );
  }
}

Icon.displayName = 'PriceTagWithDollarSignIcon';

export default Icon;
